/*

  1. Złapać submit formularza
  2. Sprawdzić czy formularz powinien zostać przesłany (walidacja)
  3. Sprawdzić captche czy nie jest to robot
  4. Jeżeli wszystko się zgadza to zbierz dane z formularza
  5. Prześlij dane z formularza do backendu
  6. Pokaż komunikat, że dane(formularz) zostały wysłane
  7. Wyczyść formularz


/**
 * Handle submit of forms with recaptcha code, validation and right message after form has been sent
 */
class RecaptchaForms {
  /**
   * @constructor
   * @param {HTMLElement} form - from to being handle by class
   */
  constructor(form) {
    this.form = form;


    if (this.init) {
      // Find all necessary elements
      this.submitBtns = this.form.querySelectorAll(`[data-recaptcha="submit"]`);
      this.hideSentMessageBtns = this.form.querySelectorAll(`[data-action="hide-sent-message"]`);

      if (this.submitBtns.length) {
        this.init();
      }
      else {
        console.error("#ERROR! RecaptchaForms couldn't find any buttons to submit");
      }
    }
    else {
      console.error("#ERROR! Given param to RecaptchaForm is not a valid HTMLElement");
    }
  }

  /**
   * Init all basic listeners and functionalities
   */
  init() {

    // Loop through all btns to submit and add right action
    this.submitBtns.forEach(btn => {
      // check if button already has added action
      if (btn.getAttribute("data-recaptcha-submit-init") === "true") {
        // if true, do nothing
        return false;
      }

      // If not, add it

      // Add attr that action is not init
      btn.setAttribute("data-recaptcha-submit-init", "true")

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        // On click submit form
        this.handleSubmit();
      })
    })

    // Loop through all btns to hide message that form has been sent and add right action
    this.hideSentMessageBtns.forEach(btn => {
      // check if button already has added action
      if (btn.getAttribute("data-recaptcha-action-init") === "true") {
        // if true, do nothing
        return false;
      }

      // If not, add it

      // Add attr that action is not init
      btn.setAttribute("data-recaptcha-action-init", "true")

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        // On click submit form
        this.hideSentMessage();
      })
    })
  }

  /**
   * Hide message that form has been sent
   */
  hideSentMessage() {
    this.form.classList.remove("isSent");
  }

  /**
   * Imitate browser submit, handle everything so form can be send to backend
   */
  handleSubmit() {
    console.log("submit");

    // Check validation
    const isValidate = this.handleValidation();
    if (isValidate) {
      this.handleCaptcha()
        .then(() => {
          // After captcha has been generated
          // Send form to backend
          this.sendForm();
        });
    }
  }

  /**
   * Send whole form to backend
   */
  async sendForm() {
    // const data = new FormData(this.form)

    // // Get url 
    // const url = this.form.getAttribute("data-url")

    // // Send info to server
    // await fetch(url, {
    //   method: 'post',
    //   body: data
    // })

    // // Add class to form that form has been sent
    // const section  = this.form.closest('[data-section="contact"]');
    // section.classList.add("isSent");

    // this.form.reset();
    this.form.submit();
  }

  /**
   * Generate captcha code and add it to form
   */
  handleCaptcha() {
    return new Promise((resolve, reject) => {

      const thisHelper = this;

      // Init captcha
      grecaptcha.ready(function () {
        //6LfLt5IbAAAAAAHonAghtx3XYeWmkXvnHMx3TcFN
        grecaptcha.execute('6LfTeLYgAAAAACUJ-Udu1r5HI3UD2m9nHPxmEA5f', { action: 'submit' })
          .then(function (token) {

            // After token has been generated create/update hidden input with captcha 
            let tokenCaptcha = thisHelper.form.querySelector(`[name='recaptcha_response']`);
            if (tokenCaptcha) {
              // If token exists, update token value
              tokenCaptcha.value = token;
            }
            else {
              // If token does not exist create it
              tokenCaptcha = document.createElement("input");
              tokenCaptcha.setAttribute("name", "recaptcha_response");
              tokenCaptcha.setAttribute("id", "recaptchaResponse");
              tokenCaptcha.setAttribute("type", "hidden");
              tokenCaptcha.setAttribute("value", token);

              // Add token to form
              thisHelper.form.appendChild(tokenCaptcha);
            }

            resolve("token generated")
          });
      });
    })
  }

  /**
   * Check validation of form
   * @returns {bool} info if form is ready to send or not
   */
  handleValidation() {
    // Variable to store if form should send or there is something wrong with validation
    let isValidate = true;

    // Find all fields that should be validation
    const allFields = this.form.querySelectorAll(`input, textarea`);

    // Loop through all fields and check validation
    allFields.forEach(field => {

      // Check if validation is correct
      if (!field.checkValidity()) {
        // If field is not validate

        // If its first wrong field, show error
        if (isValidate) {
          field.reportValidity();
        }

        isValidate = false;
      }
    })


    return isValidate
  }
}


// Get all forms that should have recaptcha
const allForms = document.querySelectorAll(`[data-reaptcha="form"]`)
if (allForms.length) {
  allForms.forEach(form => {
    // Init class to handle form
    const instance = new RecaptchaForms(form);


    setTimeout(() => {
      instance.init();
    }, 1000)
  })
}
